import React from 'react'
import Grid from '@material-ui/core/Grid'
import { Field } from 'react-final-form'
import { List, Filter, useListRepository, useFilter } from 'elentari'
import { useAbility } from '../../Usuarios'
import { getListActions } from '../../../lib/crudAuthorization'
import listaAvisoRepository from './listaAvisoRepository'
import { parseCpfOrCnpj } from '../../../utils/Parse'
import { CustomTextField } from '../../../components/CustomDisabledFields'
import { formatCpfCnpj } from '../../../utils/Formatter'
import CorAvisoSelect from './CorAvisoSelect'

const ListaAvisoFilter = () => {
  const filter = useFilter({})

  return (
    <Filter
      {...filter}
      labels={{
        simpleFilter: 'Busca simples',
        find: 'Buscar',
        clear: 'Limpar'
      }}
    >
      <Grid spacing={3} container>
        <Grid item xs={12} sm={4}>
          <Field
            fullWidth
            name="cpfCnpj"
            label="CPF / CNPJ"
            component={CustomTextField}
            format={parseCpfOrCnpj}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            fullWidth
            name="descricao"
            label="Descrição"
            component={CustomTextField}
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <CorAvisoSelect />
        </Grid>
      </Grid>
    </Filter>
  )
}

const ListaAviso = props => {
  const [ability] = useAbility()

  const listHook = useListRepository({
    repository: listaAvisoRepository,
    path: 'listaAviso',
    forceRemove: true
  })

  delete listHook.undoRemove
  listHook.deleteFItem = listHook.removeItem
  delete listHook.removeItem

  const formatColor = cor => {
    switch (cor) {
      case 'success':
        return 'Verde'
      case 'warning':
        return 'Amarelo'
      case 'error':
        return 'Vermelho'
      default:
        return 'Verde'
    }
  }

  const listOptions = {
    fields: {
      cpfCnpj: {
        label: 'CPF / CNPJ',
        format: value => formatCpfCnpj(value)
      },
      descricao: {
        label: 'Descrição'
      },
      cor: {
        label: 'Cor',
        format: formatColor
      }
    }
  }

  const actions = getListActions(ability, listHook, 'listaAviso')

  return (
    <>
      <ListaAvisoFilter />
      <List
        {...props}
        {...listHook}
        {...actions}
        stickyHeader
        adjustToScreenHeight
        onClickView={null}
        hideDownloadIcon
        listOptions={listOptions}
      />
    </>
  )
}

export default ListaAviso
